@if (value >= 0 && highValue >= 0 && options) {
  <div class="slider mat-typography mat-body mat-app-background">
    <h3>Filter by Premium Rates</h3>
    <ngx-slider [(value)]="value" [(highValue)]="highValue" [options]="options" (valueChange)="valueChange($event)"
    (highValueChange)="highValueChange($event)"></ngx-slider>
  </div>
}
